// extracted by mini-css-extract-plugin
var _1 = "SubMenuWrapper-moduleSubMenuWrapper__RGQxr";
export { _1 as "SubMenuWrapper" }
